__turbopack_context__.v({
  "amount": "AmountTextField-module-scss-module__VKXR9a__amount",
  "label": "AmountTextField-module-scss-module__VKXR9a__label",
});
